let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/* Chang Sport: remember recently viewed products (used by Top Picks > Recently Viewed) */
(function () {
  try {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var key = 'chang_recently_viewed';
    var list = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(list)) list = [];
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(key, JSON.stringify(list.slice(0, 24)));
  } catch (e) {}
})();
